import React, { FC } from "react";
import { faPlus } from "@fortawesome/pro-regular-svg-icons/faPlus";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const Plus: FC<JSX.IntrinsicAttributes> = (props) => (
  <FontAwesomeIcon icon={faPlus} {...props} />
);
